import { render } from "./ListPage.vue?vue&type=template&id=7b057f6d&scoped=true&ts=true"
import script from "./ListPage.vue?vue&type=script&lang=ts"
export * from "./ListPage.vue?vue&type=script&lang=ts"

import "./ListPage.vue?vue&type=style&index=0&id=7b057f6d&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/pontuei/pontuei-painel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b057f6d"]])

export default __exports__